"use client";
import {JSX} from "react";

import {DateHelper} from "@/shared/lib/helpers/date";
import {type DateRangePickerTriggerProps} from "@/shared/ui/form/datepickers/range/daterange-picker-field";

import "./styles/header-date-trigger.scss";

/**
 * Compact date range trigger for header search bar.
 * Shows "Jul 10 - 14" or "From - To" placeholder.
 */
export function HeaderDateTrigger(props: DateRangePickerTriggerProps): JSX.Element {
    const {startDate, endDate, disabled, hasValue, onClick} = props;

    const dateRangeValue = DateHelper.formatDateRangeCompact(startDate, endDate);

    return (
        <button type="button" onClick={onClick} disabled={disabled} className="daterange-trigger-compact">
            <span className={`daterange-trigger-compact__text ${hasValue ? "daterange-trigger-compact__text--active" : ""}`}>
                {hasValue && dateRangeValue ? dateRangeValue : "From — To"}
            </span>
        </button>
    );
}
